import { Rect } from "../../../platform/geom/Rect";
import { Buzzer } from "./Buzzer";

export const BuzzerLayout = (object: Buzzer) => {

    const base = new Rect(0, 0, object.width, object.height);
    const inner = base.inflate(-10);
    const buzz = Rect.fromCenter(inner.center(), 50);

    return { base, inner, buzz };
};

export type BuzzerLayout = ReturnType<typeof BuzzerLayout>;